import React from "react";
import EditButton from "components/CustomButtons/EditButton";
import Dialog from "@mui/material/Dialog";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { makeStyles } from "@mui/styles";
import Button from "@mui/material/Button";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "65ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
}));

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

export default function ErrorFallback({ error, resetErrorBoundary, page }) {

  const classes = useStyles();

  return (
    <Dialog
      onClose={resetErrorBoundary}
      aria-labelledby="edituser-dialog-title"
      fullWidth="true"
      maxWidth="sm"
      open={true}
    >
      <CustomDialogTitle id="customized-dialog-title" onClose={resetErrorBoundary}>
        Une erreur est survenue
      </CustomDialogTitle>
      <DialogContent>
        <form className={classes.root}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <div>
                Vous pouvez contacter le support technique <a href="https://helpdesk.avob.com/portal/fr/home" target="_blank">ici</a> pour signaler l'erreur.
              </div>
              <Button
                className={classes.submitButton}
                onClick={() => {
                  resetErrorBoundary();
                }}
              >
                Fermer
              </Button>
            </GridItem>
          </GridContainer>
        </form>
      </DialogContent>
      <DialogActions></DialogActions>
    </Dialog>
  );
}
